/* Redo: text-only responsive placeholder sync. Never move or clone Impulse search. */
(function () {
  if (window.__redcampHeaderV10Redo) return;
  window.__redcampHeaderV10Redo = true;
  var breakpoint = window.matchMedia('(max-width: 768px)');
  function updatePrompt() {
    document.querySelectorAll('.rd-header .site-header__search-input[data-desktop-placeholder]').forEach(function (field) {
      field.placeholder = breakpoint.matches
        ? (field.getAttribute('data-mobile-placeholder') || field.getAttribute('data-desktop-placeholder') || '')
        : (field.getAttribute('data-desktop-placeholder') || '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updatePrompt, {once:true});
  else updatePrompt();
  if (breakpoint.addEventListener) breakpoint.addEventListener('change', updatePrompt);
  else breakpoint.addListener(updatePrompt);
  document.addEventListener('shopify:section:load', updatePrompt);
})();
